<template>
    <div class="card mt-5">
        <div class="card-header bg-primary text-white">
            <div class="card-title h5 m-0">
                {{ panel.label }} / {{ panel.labelEn }}
                <i class="fas fa-edit float-right pointer" @click="editPanelInfo"></i>
            </div>
        </div>
        <div class="card-body row">
            <draggable v-model="panel.components" @start="draggableDragStart" @end="draggableDragEnd" class="row col-12" :options="{animation:150}">
            <!--    <transition-group name="componentAnimation" enter-active-class="animated lightSpeedIn" class="row col-12">-->
                    <component class="dropitem"
                               v-for="component in panel.components"
                               :is="component.fieldType"
                               :type="component.type"
                               :key="component.sort"
                               :model="component"
                               :isFormField="isFormField"
                               :isAuxRegisterField="isAuxRegisterField"
                               :isEventFieldCode="isEventFieldCode">
                    </component>
              <!--  </transition-group>-->
            </draggable>
        </div>

        <vs-prompt
                :title="$t('editor.panel.editPanelName')"
                :accept-text="$t('buttons.ok')"
                :cancel-text="$t('buttons.cancel')"
                :active.sync="activePrompt"
                :is-valid="validationSuccess"
                @accept="acceptPrompt"
                color="primary">
            <div>
                <div v-if="panel.locked">
                    <h4 class="text-danger"><i class="fas fa-lock"></i> {{ $t('registers.dynamic.gridHeaders.locked') }}</h4>
                </div>

                <div v-if="panel.isEvaluationPanel">
                    <div v-if="participationTypesLoaded">
                        <vs-select v-model="panel.participationTypeId"
                                   :label="$t('editor.panel.participationType')"
                                   width="100%"
                                   autocomplete
                                   :placeholder="$t('choose')">
                            <vs-select-item :key="index"
                                            autocomplete
                                            :value="item.id"
                                            :text="item.text"
                                            v-for="(item,index) in participationTypes" />
                        </vs-select>
                    </div>
                    <div v-else class="smallLoader"></div>
                </div>
                <div v-else>
                    <vs-input :label="$t('editor.panel.panelName')" v-model="panelName" />
                    <span class="text-danger" v-if="!validName">{{ $t('validation.requiredField') }}</span>
                    <vs-input :label="$t('editor.panel.panelNameEn')" v-model="panelNameEn"></vs-input>

                    <vs-input :label="$t('editor.panel.panelLabel')" v-model="panelLabel" />
                    <span class="text-danger" v-if="!validLabel">{{ $t('validation.requiredField') }}</span>
                    <vs-input :label="$t('editor.panel.panelLabelEn')" v-model="panelLabelEn"></vs-input>
                    <span class="text-danger" v-if="!validLabelEn">{{ $t('validation.requiredField') }}</span>
                </div>
            </div>
        </vs-prompt>
    </div>
</template>

<script>
    import Input from '../../components/editor/Input';
    import Datepicker from '../../components/editor/Datepicker';
    import Dropdown from '../../components/editor/Dropdown';
    import Toggle from '../../components/editor/Toggle';
    import PersonIdentification from '../../components/editor/PersonIdentification';
    import Person from '../../components/editor/Person';
    import PersonList from './PersonList';
    import FileUpload from './FileUpload';
    import Address from './Address';
    import StarRating from '../../components/editor/StarRating';
    import Draggable from 'vuedraggable';
    import { Role } from '../../helpers/role';

    export default {
        props: {
            panel: Object,
            isFormField: {
                type: Boolean,
                default: false
            },
            isAuxRegisterField: {
                type: Boolean,
                required: false
            },
            isEventFieldCode: {
                type: Boolean,
                required: false
            },
        },
        components: {
            Draggable,
            Input,
            Toggle,
            Dropdown,
            Datepicker,
            PersonIdentification,
            FileUpload,
            Person,
            Address,
            PersonList,
            StarRating
        },
        data() {
            return {
                activePrompt: false,
                panelName: '',
                panelNameEn: '',
                panelLabel: '',
                panelLabelEn: '',
                participationTypesLoaded: false,
                participationTypes: []
            }
        },
        methods: {
            editPanelInfo(event) {
                this.panelName = this.panel.name;
                this.panelNameEn = this.panel.nameEn;
                this.panelLabel = this.panel.label;
                this.panelLabelEn = this.panel.labelEn;
                this.activePrompt = true;
            },
            acceptPrompt(event) {
                if (!this.validName || !this.validLabel || !this.validLabelEn) {
                    return;
                }
                this.panel.name = this.panelName;
                this.panel.nameEn = this.panelNameEn;
                this.panel.label = this.panelLabel;
                this.panel.labelEn = this.panelLabelEn;
            },
            draggableDragStart() {
                this.drag = true;
                this.$emit('dragging', true);
            },
            draggableDragEnd() {
                this.drag = false;
                this.$emit('dragging', false);
            },
            loadParticipationTypes() {
                this.$http.get('/api/ParticipationType/getDropdownModels').then(result => {
                    if (result && result.data) {
                        this.participationTypes = result.data;
                    }
                    this.participationTypesLoaded = true;
                }).catch(error => {
                   console.error(error);
                });
            }
        },
        computed: {
            validName() {
                return this.panelName.length > 0;
            },
            validLabel() {
                return this.panelLabel.length > 0;
            },
            validLabelEn() {
                return this.panelLabelEn.length > 0;
            },
            validationSuccess() {
                // this.mode.locked - Locked for edition
                return !this.panel.locked && this.validName && this.validLabel && this.validLabelEn
            },
            hasFieldCodeEditRights() {
                return this.$store.getters.userRoles.includes(Role.DevAdmin.toString());
            }
        },
        mounted () {
            if (this.panel.isEvaluationPanel) {
                this.loadParticipationTypes();
            }
        }
    }
</script>

<style scoped>
    .vs-input {
        width: 100%;
    }

    .trashzone .dropitem {
        display: none;
    }

    ::v-deep {
        .vs-dialog {
            min-width: 800px !important;
            height: auto;
        }
    }
</style>
